import * as React from 'react';
import globalBreakpointMd from '@patternfly/react-tokens/dist/js/global_breakpoint_md';
import globalBreakpointLg from '@patternfly/react-tokens/dist/js/global_breakpoint_lg';
import globalBreakpointXl from '@patternfly/react-tokens/dist/js/global_breakpoint_xl';
import globalBreakpoint2xl from '@patternfly/react-tokens/dist/js/global_breakpoint_2xl';
export var ToolbarContext = React.createContext({
  isExpanded: false,
  toggleIsExpanded: function toggleIsExpanded() {},
  chipGroupContentRef: null,
  updateNumberFilters: function updateNumberFilters() {},
  numberOfFilters: 0,
  clearAllFilters: function clearAllFilters() {}
});
export var ToolbarContentContext = React.createContext({
  expandableContentRef: null,
  expandableContentId: '',
  chipContainerRef: null
});
export var globalBreakpoints = {
  md: parseInt(globalBreakpointMd.value),
  lg: parseInt(globalBreakpointLg.value),
  xl: parseInt(globalBreakpointXl.value),
  '2xl': parseInt(globalBreakpoint2xl.value)
};